import { Link } from "@inertiajs/react";
import dayjs from "dayjs";
import { useCurrencyParser, useTitleCase } from "@/hooks";
import Tooltip from "@/components/Universal/Tooltip";
import { usePage } from "@inertiajs/react";

dayjs.locale("id");

const CardList = ({ events }) => {
    // const dataevent = Array.from(events.data);
    const { storage_url } = usePage().props;

    const Label = ({ content }) => (
        <div className="badge-pill mb-1">
            <span className="text-capitalize">{content}</span>
        </div>
    );

    const CardTitle = ({ data }) => {
        const title = data.judul
            ? `${data.nama.toUpperCase()} : ${data.judul}`
            : data.nama.toUpperCase();
        return (
            <>
                {data.judul ? (
                    <p className="card-title">
                        {title.length > 50
                            ? `${title.substring(0, 50)} ...`
                            : title}
                    </p>
                ) : (
                    <p className="card-title">{title}</p>
                )}
            </>
        );
    };

    return events.map((data, i) => {
        return (
            <div className="col-12 col-md-6 col-lg-3 mb-5" key={i}>
                <div className="d-flex justify-content-center">
                    <div className="card card_event">
                        <Link
                            className="text-decoration-none"
                            href={`/event/${data.slug}`}
                        >
                            {data.poster_path ? (
                                <img
                                    className="card__poster"
                                    src={`${storage_url}${data.poster_path}`}
                                    alt={data.judul}
                                ></img>
                            ) : (
                                <img
                                    className="card__poster"
                                    src="/images/poster-not-available.png"
                                    alt="poster-not-available"
                                ></img>
                            )}
                        </Link>
                        <Link
                            className="card-body text-decoration-none"
                            href={`/event/${data.slug}`}
                        >
                            <div className="d-flex gap-1 flex-wrap">
                                <Tooltip
                                    title={useTitleCase(data.jenis)}
                                    placement="top"
                                >
                                    <Label content={data.jenis} />
                                </Tooltip>
                                {data.tema && (
                                    <Tooltip
                                        title={useTitleCase(data.tema)}
                                        placement="top"
                                    >
                                        <Label content={data.tema} />
                                    </Tooltip>
                                )}
                            </div>
                            <CardTitle data={data} />
                            <span className="card__latar">
                                <i className="far fa-calendar"></i>
                                &nbsp; &nbsp;
                                {dayjs(data.tgl_mulai).format("DD MMMM YYYY")}
                                <br />
                                <i className="fas fa-map-marker-alt"></i>
                                &nbsp; &nbsp;{data.kota}
                            </span>
                            <div className="harga">
                                {data.min_harga == data.max_harga
                                    ? data.min_harga == 0
                                        ? "Gratis"
                                        : useCurrencyParser(data.min_harga)
                                    : useCurrencyParser(data.min_harga) +
                                      " - " +
                                      useCurrencyParser(data.max_harga)}
                            </div>
                            <hr className="hr" />
                            <Link
                                className="d-flex justify-content-start align-items-center gap-2 text-decoration-none"
                                href={`/organizer/${data.organizer_slug}`}
                            >
                                <img
                                    className="rounded-circle"
                                    src={
                                        data?.organizer_logo
                                            ? `${storage_url}${data.organizer_logo}`
                                            : "/images/poster-not-available.png"
                                    }
                                    alt="Logo Organizer"
                                    width={30}
                                />
                                <span className="text-body text-truncate text-sm">
                                    {data.organizer_nama}
                                </span>
                            </Link>
                        </Link>
                    </div>
                </div>
            </div>
        );
    });
};

const noData = (resetFilter) => {
    // console.log('apa ini', resetFilter.resetFilter)
    const yangdicari = resetFilter.resetFilter.search;
    const dataSort = resetFilter.resetFilter.optionSort;
    let data_Filter = resetFilter.resetFilter.optionFilter; //Menampilkan data filter user dari controller ( $filter_terpilih = $request->arrayFilter;)    //Menampilkan data filter user dari controller ($filter_array =explode(" ",$filter_terpilih);)
    const price = resetFilter.resetFilter.gratis;
    const highestPrice = resetFilter.resetFilter.highestPrice;
    const lowestPrice = resetFilter.resetFilter.lowestPrice;
    const location1 = resetFilter.resetFilter.location1;
    const location2 = resetFilter.resetFilter.location2;
    return (
        <>
            <div className="no-event">
                <img src={`/images/empty_state.png`} alt="not found" />
                <p>
                    Mohon maaf tidak ada event tersedia yang sesuai dengan
                    kriteria pencarian Anda :({" "}
                </p>
                {(data_Filter == "" &&
                    price == "null" &&
                    highestPrice == "null" &&
                    lowestPrice == "null" &&
                    location1 == "null" &&
                    location2 == "null") ||
                (data_Filter == "" &&
                    price == null &&
                    highestPrice == null &&
                    lowestPrice == null &&
                    location1 == null &&
                    location2 == null) ? (
                    ""
                ) : (
                    <a
                        href={`/event?pencarian=${yangdicari}&sortOption=${dataSort}`}
                        className="btn btn-filter-blue"
                    >
                        Reset Filter
                    </a>
                )}
            </div>
        </>
    );
};

const CekData = (events) => {
    const isiEvents = events.events.length;
    // events.events.event.data.length
    return isiEvents == 0 ? (
        noData(events)
    ) : (
        <>
            <div className="container">
                <div className="row">{CardList(events)}</div>
            </div>
        </>
    );
};

export default CekData;
